import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-weather-forecast",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("../locations-common/settings"),
  presets: [
    {
      label: "bcm:widgets.weather-forecast.name",
      description: "bcm:widgets.weather-forecast.description",
      imageLink: require("./screenshot.png"),
      layout: [8, 8],
      widget: {
        config: {},
      },
    },
  ],
});
